import { Injectable } from '@angular/core';
import { QuickAdditEntity } from '../classes/entity.class';

@Injectable()
export class QuickAdditService {

    /**
     * Registered entities
     *
     * @type {Array}
     */
    protected entities = [];

    public constructor() {

    }

    public register(name: string, service: Object) {

        if (this.entities.filter(entity => entity.name === name).length > 0) {
            throw new Error('Cannot register QuickAddit entity. There is already an entity registered with the name; `' + name + '`');
        }

        const newEntity = new QuickAdditEntity(name, service);
        this.entities   = this.entities.concat([newEntity]);

        return newEntity;

    }

    public extend(name: string) {
        return this.get(name);
    }

    public get(name: string): QuickAdditEntity {

        return this.entities.find(entity => entity.name === name);

    }

    public remove(name: string) {
        this.entities = this.entities.filter(entity => entity.name !== name);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/quick-addit/services/quick-addit.service.ts